import { debounce, isTryOnMobile } from '../../../scripts/utils/utils';

const slider = document.querySelector('.to__glasses--grid');
if (!slider) return;

let isMobile = isTryOnMobile();
let oldIsMobile = isMobile;
const Flickity = themeVendor.Flickity;
let flkty;

function handleWindowResize() {
  isMobile = isTryOnMobile();
  if (isMobile === oldIsMobile) return;
  oldIsMobile = isMobile;

  if (isMobile) initMobileView();
  else destroyMobileView();
}

function initMobileView() {
  flkty = new Flickity(slider, {
    prevNextButtons: false,
    pageDots: false,
    setGallerySize: false,
    cellSelector: '.carousel-cell',
    wrapAround: true,
    on: {
      change: (index) => {
        debounceTriggerSetFrame(index);
        handleTryOnSliderScroll(index);
      },
      ready: () => {
        setTimeout(() => flkty.resize(), 100);
      },
      staticClick: (event, pointer, cellElement, cellIndex) => {
        if (cellElement && cellIndex !== flkty.selectedIndex) {
          flkty.select(cellIndex);
        }
      }
    }
  });

  allowCpExpandEvents();
  document.body?.classList.add('to_mobile');
}

function destroyMobileView() {
  flkty.destroy();
  allowCpExpandEvents(false);
  document.body?.classList.remove('to_mobile');
}

const debounceTriggerSetFrame = debounce((index) => {
  const catalougWrapper = document.querySelector('.to__catalogue--wrapper');
  let selectedGlasses = catalougWrapper?.querySelector('.to-glasses-wrapper.is-selected');

  if (!selectedGlasses) {
    selectedGlasses = catalougWrapper?.querySelectorAll('.to-glasses-wrapper')[index - 1];
  }

  const detail = { selectedGlasses: selectedGlasses };
  const mobileFrameSelected = new CustomEvent('try-on:frame-changed', { detail });
  document.dispatchEvent(mobileFrameSelected);
}, 200);

function allowCpExpandEvents(enable = true) {
  const expandableConnectedProducts = slider?.querySelectorAll('.to-connected-products.not-expanded');

  expandableConnectedProducts.forEach(expandableCP => {
    const expandCpProd = expandConnectedProducts.bind(this, expandableCP);

    if (enable) expandableCP.addEventListener('click', expandCpProd);
    if (!enable) expandableCP.removeEventListener('click', expandCpProd);
  });

  function expandConnectedProducts(expandableCP) {
    expandableCP.classList.remove('not-expanded');
    expandableCP.removeEventListener('click', expandConnectedProducts);
  }
}

function appendNewSlides(e) {
  const elements = e.detail.newSlides;
  if (!elements) return;

  const parser = new DOMParser();
  let newSlides = elements.map(slide => parser.parseFromString(slide, "text/html")?.querySelector('.carousel-cell')).filter(slide => slide);
  flkty.append(newSlides);

  allowCpExpandEvents();

  document.removeEventListener('try-on:loaded-glasses', appendNewSlides);
}

function handleTryOnSliderScroll(index) {
  const expandableConnectedProducts = slider?.querySelectorAll('.to-connected-products');
  const slides = expandableConnectedProducts?.length;

  if (slides && index >= (slides - 4)) {
    const loadMoreGlassesEvent = new CustomEvent('try-on:load-more-glasses');
    document.dispatchEvent(loadMoreGlassesEvent);

    document.addEventListener('try-on:loaded-glasses', appendNewSlides);
  }
}

if (isMobile) initMobileView();

window.addEventListener('resize', handleWindowResize);